/**
 * The color identifiers supported by the theme.
 */
export var ThemeColor;
(function (ThemeColor) {
    ThemeColor["Primary"] = "primary";
    ThemeColor["Secondary"] = "secondary";
    ThemeColor["Light"] = "light";
    ThemeColor["Dark"] = "dark";
    ThemeColor["Info"] = "info";
    ThemeColor["Success"] = "success";
    ThemeColor["Danger"] = "danger";
    ThemeColor["Warning"] = "warning";
})(ThemeColor || (ThemeColor = {}));
/**
 * For each color of the theme, its corresponding reverse color identifier.
 */
export const ThemeInverseColor = {
    [ThemeColor.Primary]: ThemeColor.Light,
    [ThemeColor.Secondary]: ThemeColor.Light,
    [ThemeColor.Light]: ThemeColor.Dark,
    [ThemeColor.Dark]: ThemeColor.Light,
    [ThemeColor.Info]: ThemeColor.Light,
    [ThemeColor.Success]: ThemeColor.Light,
    [ThemeColor.Danger]: ThemeColor.Light,
    [ThemeColor.Warning]: ThemeColor.Light,
};
/**
 * Hexadecimal color codes, specific to Leavy's branding.
 */
export var LvBrandColorValue;
(function (LvBrandColorValue) {
    LvBrandColorValue["Grey"] = "#FCF9F9";
    LvBrandColorValue["Dark"] = "#1C1B19";
    LvBrandColorValue["Orange"] = "#FF5B17";
    LvBrandColorValue["Pink"] = "#FA9FCB";
    LvBrandColorValue["Violet"] = "#4343E7";
    LvBrandColorValue["Blue"] = "#5FDCF2";
    LvBrandColorValue["Yellow"] = "#FAEF34";
    LvBrandColorValue["Green"] = "#5FEF62";
})(LvBrandColorValue || (LvBrandColorValue = {}));
/**
 * For each color of the theme, its corresponding hexadecimal code.
 */
export const ThemeColorValue = {
    [ThemeColor.Primary]: LvBrandColorValue.Violet,
    [ThemeColor.Secondary]: LvBrandColorValue.Dark,
    [ThemeColor.Light]: "#FFFFFF",
    [ThemeColor.Dark]: LvBrandColorValue.Dark,
    [ThemeColor.Info]: "#3ea5e3",
    [ThemeColor.Success]: "#26bf4c",
    [ThemeColor.Danger]: "#faa05a",
    [ThemeColor.Warning]: "#de4a52",
};
/**
 * Responsive breakpoints supported by the theme.
 */
export var ThemeBreakpoint;
(function (ThemeBreakpoint) {
    ThemeBreakpoint["XS"] = "xs";
    ThemeBreakpoint["SM"] = "sm";
    ThemeBreakpoint["MD"] = "md";
    ThemeBreakpoint["LG"] = "lg";
})(ThemeBreakpoint || (ThemeBreakpoint = {}));
/**
 * For each breakpoint, its corresponding value in pixels.
 */
export var ThemeBreakpointValue;
(function (ThemeBreakpointValue) {
    ThemeBreakpointValue[ThemeBreakpointValue["XS"] = 0] = "XS";
    ThemeBreakpointValue[ThemeBreakpointValue["SM"] = 768] = "SM";
    ThemeBreakpointValue[ThemeBreakpointValue["MD"] = 992] = "MD";
    ThemeBreakpointValue[ThemeBreakpointValue["LG"] = 1200] = "LG";
})(ThemeBreakpointValue || (ThemeBreakpointValue = {}));
/**
 * For each breakpoints, its minimum and maximum boundaries in pixels.
 */
export const ThemeBreakpointBoundaries = {
    [ThemeBreakpoint.XS]: {
        min: ThemeBreakpointValue.XS,
        max: ThemeBreakpointValue.SM - 1
    },
    [ThemeBreakpoint.SM]: {
        min: ThemeBreakpointValue.SM,
        max: ThemeBreakpointValue.MD - 1
    },
    [ThemeBreakpoint.MD]: {
        min: ThemeBreakpointValue.MD,
        max: ThemeBreakpointValue.LG - 1
    },
    [ThemeBreakpoint.LG]: {
        min: ThemeBreakpointValue.LG,
        max: undefined
    },
};
//# sourceMappingURL=variables.js.map